import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import Loader from './EvaluatorPageLoader';
import './EvaluatorInterface.css';

export default function ProcessSelection({ processos, loading, faculdade, user }) {
    const [filter, setFilter] = useState('all');
        let now = moment();
        let processos_ativos = processos.filter((item) => now.isSameOrAfter(moment(item.inicio)) && now.isSameOrBefore(moment(item.fim))).length;
        let processos_agendados = processos.filter((item) => now.isBefore(moment(item.inicio))).length;
        let processos_encerrados = processos.filter((item) => now.isAfter(moment(item.fim))).length;
        let processos_filtrados = processos.filter((item) => {
            let inicio = moment(item.inicio);
            let fim = moment(item.fim);
            if (filter == 'active') return now.isSameOrAfter(inicio) && now.isSameOrBefore(fim);
            if (filter == 'scheduled') return now.isBefore(inicio);
            if (filter == 'closed') return now.isAfter(fim);
            return true;
        });
        return (
            <div className="row evaluator-process-page">


                <div className="col-12">
                    <div className="evaluator-process-card">
                        <div className="card-body">
                            <nav className="evaluator-breadcrumb" aria-label="breadcrumb">
                                <Link to="/">{"Início"}</Link>
                                <i className="mdi mdi-chevron-right"></i>
                                <span>{faculdade.name}</span>
                                <i className="mdi mdi-chevron-right"></i>
                                <strong>{"Processos"}</strong>
                            </nav>
                            <div className="d-flex justify-content-between evaluator-process-head">
                                <div>
                                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>
                                        {"Painel do avaliador"}
                                    </h4>
                                    <p style={{ fontSize: '1rem', color: 'black' }}>{"Nome do avaliador"}: {user.name}</p>
                                </div>

                            </div>

                            <hr />
                            <div className="evaluator-process-section-head">
                                <div>
                                    <span>{"Provas orais"}</span>
                                    <h4 className="mt-0 header-title evaluator-table-title" style={{ fontSize: '1.5rem', color: 'black' }}>{"Selecione uma avaliação"}</h4>
                                    <p className="evaluator-table-subtitle" style={{ fontSize: '1rem', color: 'black' }}>{"Acesse os processos vinculados ao seu usuário para conduzir entrevistas e registrar as avaliações."}</p>
                                </div>
                                <strong>{processos.length} {processos.length == 1 ? "processo" : "processos"}</strong>
                            </div>

                            <div className="evaluator-process-filters">
                                <button type="button" onClick={() => setFilter('all')} className={filter == 'all' ? 'active' : ''}><i className="mdi mdi-view-list-outline"></i> {"Todos"} <strong>{processos.length}</strong></button>
                                <button type="button" onClick={() => setFilter('active')} className={filter == 'active' ? 'active' : ''}><i className="mdi mdi-radiobox-marked"></i> {"Em andamento"} <strong>{processos_ativos}</strong></button>
                                <button type="button" onClick={() => setFilter('scheduled')} className={filter == 'scheduled' ? 'active' : ''}><i className="mdi mdi-calendar-clock"></i> {"Não iniciados"} <strong>{processos_agendados}</strong></button>
                                <button type="button" onClick={() => setFilter('closed')} className={filter == 'closed' ? 'active' : ''}><i className="mdi mdi-check-circle-outline"></i> {"Encerrados"} <strong>{processos_encerrados}</strong></button>
                            </div>

                            {loading == false && <div>

                                <div className="evaluator-process-list">
                                    {processos_filtrados.map((item) => {
                                        let inicio = moment(item.inicio);
                                        let fim = moment(item.fim);
                                        let status = now.isBefore(inicio) ? "Não iniciado" : (now.isAfter(fim) ? "Encerrado" : "Em andamento");
                                        let statusClass = now.isBefore(inicio) ? 'scheduled' : (now.isAfter(fim) ? 'closed' : 'active');
                                        return (
                                            <Link key={item.id} to={'/sala/' + item.id} className="evaluator-process-item">
                                                <div className={'evaluator-process-status ' + statusClass}>
                                                    <span></span>{status}
                                                </div>
                                                <div className="evaluator-process-main">
                                                    <div className="evaluator-process-icon">
                                                        <i className="mdi mdi-microphone-outline"></i>
                                                    </div>
                                                    <div>
                                                        <h5>{item.name}</h5>
                                                        <p>{"Entrevistas, acompanhamento dos candidatos e avaliação da prova oral"}</p>
                                                    </div>
                                                </div>
                                                <div className="evaluator-process-dates">
                                                    <div>
                                                        <small>{"Início"}</small>
                                                        <strong>{inicio.format('DD/MM/YYYY')}</strong>
                                                        <span>{inicio.format('HH:mm')}</span>
                                                    </div>
                                                    <div>
                                                        <small>{"Encerramento"}</small>
                                                        <strong>{fim.format('DD/MM/YYYY')}</strong>
                                                        <span>{fim.format('HH:mm')}</span>
                                                    </div>
                                                </div>
                                                <div className="evaluator-process-access">
                                                    <span>{"Acessar avaliação"}</span>
                                                    <i className="mdi mdi-arrow-right"></i>
                                                </div>
                                            </Link>
                                        )
                                    })}
                                </div>
                                {processos.length == 0 && <div className="evaluator-process-empty">
                                    <i className="mdi mdi-clipboard-alert-outline"></i>
                                    <p>{"Você não está vinculado a nenhum processo."}</p>
                                </div>}
                                {processos.length > 0 && processos_filtrados.length == 0 && <div className="evaluator-process-empty">
                                    <i className="mdi mdi-filter-remove-outline"></i>
                                    <p>{"Nenhum processo encontrado com o status \"{status}\".".replace('{status}', filter == 'active' ? "Em andamento" : (filter == 'scheduled' ? "Não iniciado" : "Encerrado"))}</p>
                                </div>}

                            </div>}

                            {loading == true && <Loader />}

                        </div>
                    </div>
                </div>

            </div>

        );
}
